import React from 'react'

const ThumbDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    {...props}
  >
    <path
      d='M4.5 2.25H12V12L6.75 17.25L5.8125 16.3125C5.725 16.225 5.65313 16.1063 5.59688 15.9563C5.54063 15.8063 5.5125 15.6625 5.5125 15.525V15.2625L6.3375 12H2.25C1.85 12 1.5 11.85 1.2 11.55C0.9 11.25 0.75 10.9 0.75 10.5V9C0.75 8.9125 0.759375 8.81875 0.778125 8.71875C0.796875 8.61875 0.825 8.525 0.8625 8.4375L3.1125 3.15C3.225 2.9 3.4125 2.6875 3.675 2.5125C3.9375 2.3375 4.2125 2.25 4.5 2.25ZM13.5 12V2.25H16.5V12H13.5Z'
      fill='currentColor'
    />
  </svg>
)

export default ThumbDownIcon
